import { Injectable } from '@angular/core';
import { PostmethodService } from '../../app-config/postmethod.service';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LikehoodMasterService {
  constructor(private ws: PostmethodService) {}

  getLikeHoodMaster(): Observable<any> {
    const requestPayload = { flag: 'list' };
    return this.ws.wsPost(
      requestPayload,
      environment.masterUrl + 'likelihoodToPurchasesMaster'
    );
  }

  createLikehoodMaster(data: any): Observable<any> {
    const requestPayload = { ...data, flag: 'create' };
    return this.ws.wsPost(
      requestPayload,
      environment.masterUrl + 'likelihoodToPurchasesMaster'
    );
  }

  updateLikeHoodlMaster(id: number, data: any): Observable<any> {
    const requestPayload = { ...data, flag: 'update', id };
    return this.ws.wsPost(
      requestPayload,
      environment.masterUrl + 'likelihoodToPurchasesMaster'
    );
  }
}
